import { useStore } from 'react-admin';
import { Partner } from '@src/types';

export const useTitle = (baseTitle: string) => {
  const [currentPartner] = useStore<Partner | null>('currentPartner', null);
  const title = currentPartner ?
    `${currentPartner.name} - ${baseTitle}` :
    baseTitle;
  return { title };
};
